/* eslint-disable */
export default {
  forward: 'Encaminhar',
  ignore: 'Ignorar',
  toVoicemail: 'Para caixa postal',
  answer: 'Atender',
  endAndAnswer: 'Encerrar e atender',
  holdAndAnswer: 'Colocar em espera e atender',
  custom: 'Personalizada',
  more: 'Mais',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
// @key: @#@"ignore"@#@ @source: @#@"Ignore"@#@
// @key: @#@"toVoicemail"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"answer"@#@ @source: @#@"Answer"@#@
// @key: @#@"endAndAnswer"@#@ @source: @#@"End & Answer"@#@
// @key: @#@"holdAndAnswer"@#@ @source: @#@"Hold & Answer"@#@
// @key: @#@"custom"@#@ @source: @#@"Custom"@#@
// @key: @#@"more"@#@ @source: @#@"More"@#@
